import { useDispatch as useDispatchBase } from 'react-redux';
import { AppDispatch } from '~/store';

export const useDispatch = () => useDispatchBase<AppDispatch>();
